import ClientService from "./client.service";
import UserService from "./user.service";
import axios from "axios";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import AdminService from "./admin.service";
import $ from "jquery";
const BASE_URL = AdminService.getBaseUrl();
const API_URL = "/api/v1/chart";
const DEFAULT_FONT_SIZE = 10;

class EChartsService {
    labelLayout(params) {
        return {
            x: params.rect.x + 5,
            y: params.rect.y + params.rect.height / 2,
            verticalAlign: 'middle',
            align: 'left'
        }
    }
    setOptions(chartOptions, yAxisData, seriesData,header){
        chartOptions = this.setSeriesData(chartOptions, seriesData);
        $.extend(true, chartOptions, this.getBaseOptionsForChart());
        $.extend(true, chartOptions.yAxis, this.getBaseYAxis());
        chartOptions.yAxis.data.push(yAxisData);

        let isWillingnessToPay = header.indexOf("Willingness to Pay") > -1;
        let data = this.parseSeriesDataForSankeyChart(chartOptions,isWillingnessToPay);
        chartOptions = this.getOptionsForSankeyChart(data,header,isWillingnessToPay);
        return chartOptions;
    }
    /* Sankey Parser Functions start */
    parseSeriesDataForSankeyChart(chartOptions,isWillingnessToPay){
        let returnSeriesData = [];
        let seriesData = chartOptions.series;
        for (let i = 0; i < seriesData.length; i++){
          let oldSeriesEntry = seriesData[i].data[0];
          let color = seriesData[i].color;
          let newSeriesEntry = {
            name: oldSeriesEntry.name,
            value: oldSeriesEntry.value,
            color: color,
          };
          returnSeriesData.push(newSeriesEntry);
        }
        // order the seriesData by value in descending order
        returnSeriesData.sort((a, b) => b.value - a.value);
        if (isWillingnessToPay == true){
            for (let i = 0; i < returnSeriesData.length; i++){
                // if the string length is larger than 18 then truncate it to 14 characters and add 3 .
                if (returnSeriesData[i].name.length > 19){
                    returnSeriesData[i].name = returnSeriesData[i].name.substring(0, 16) + "...";
                }
            }
        }
        return returnSeriesData;
    }
    getBaseLabelForSankeyChart(formatter,isWilingnessToPay,index=0){
        let position = isWilingnessToPay == true ? 'bottom' : 'right';
        // dertermine if index is odd or even
        if (isWilingnessToPay == true && index % 2 == 0 && index != 0){
            position = 'top';
        }
        let options = {
            position: position,
            color: "#000",
            fontSize: 10.5,
            fontFamily: "Franklin Gothic Demi Cond"                        ,
            formatter: formatter,
        };
/*        
        if (isWilingnessToPay == true){
            $.extend(true, options, {rotate: 25});
        }
*/            
        return options;
    }
    getDataEntry(dataEntry,isWilingnessToPay,index){
        
        let name =  dataEntry.name + " " + dataEntry.value + "%";
        let formatter = dataEntry.name + "\n" + dataEntry.value + "%";
            return  {
            name: name,
            itemStyle: {
                color: dataEntry.color
            },
            label: this.getBaseLabelForSankeyChart(formatter,isWilingnessToPay,index),
        };
    }
    getLinkEntry(dataEntry, source){
        return {
            source: source,
            target: dataEntry.name + ' ' + dataEntry.value + '%',
            value: dataEntry.value
        };     
    }
    getDataAndLinkOptionsForSankeyChart(seriesData,isWilingnessToPay,source = 'Revenue TTM'){

        let formatter = source.replace(/<br\/?>/g, '\n');
        let metricsColor = isWilingnessToPay == true ? '#A6A6A6' : '#3B7D23';
        let metricsEntry = {
            name: source,
            itemStyle: {
                color: metricsColor
            },
            label: this.getBaseLabelForSankeyChart(formatter,isWilingnessToPay),
        };
        let optionsData = [];
        let linksData = [];
        optionsData.push(metricsEntry);
        for (let i = 0; i < seriesData.length; i++){
            optionsData.push(this.getDataEntry(seriesData[i],isWilingnessToPay,i+1));
            linksData.push(this.getLinkEntry(seriesData[i],source));
        }
        let options = {
            data: optionsData,
            links: linksData
        };
        return options;
    }
    getOptionsForSankeyChart(seriesData,metricName,isWilingnessToPay = false){
        let chartOptions = this.getBaseOptionsForSankeyChart(isWilingnessToPay);
        if (isWilingnessToPay == true){
            $.extend(true, chartOptions.series, this.getVerticalConfiguration(isWilingnessToPay));
        }
        $.extend(true, chartOptions, {series: this.getDataAndLinkOptionsForSankeyChart(seriesData,isWilingnessToPay,metricName)}); 
        return chartOptions;
    }
    getVerticalConfiguration(){
        return {
            orient: 'vertical',
            width: 300,
            height: '70%',   
            //nodeWidth:25, 
            nodeGap: 40,      
            layoutIterations: 150,
            right: '10%',
            left:'7%'
        };
    }
    getBaseOptionsForSankeyChart(isWilingnessToPay){
          let lineStyleColor = isWilingnessToPay == true ? '#F2F2F2' : '#B4E5A2';
          return {
              series: {
                  type: 'sankey',
                  layout: 'none',
                  emphasis: {
                    focus: 'adjacency',
                    color: '#a6a6a6'
                  },
                  lineStyle: {
                    color: lineStyleColor,
                    opacity: 1,
                  }, 
                  width: '50%',
                  height: '90%',
                  nodeWidth:5,
                  nodeGap: 20,
                  orient: 'horizontal',
              }
          };
    } 
    /* Sankey Parser Functions end */
    setSeriesData(chartOptions, seriesData){
        for (var pricingPowerSeriesIndex = 0; pricingPowerSeriesIndex < seriesData.series.length; pricingPowerSeriesIndex++) {
            let baseSeries = this.getBaseBarServiceForChart();
            baseSeries.color = seriesData.series[pricingPowerSeriesIndex].color;
            baseSeries.label.color = seriesData.series[pricingPowerSeriesIndex].label.color;
            baseSeries.data = seriesData.series[pricingPowerSeriesIndex].data;
            let dataList = seriesData.series[pricingPowerSeriesIndex].data;
            let data = dataList[0];
            baseSeries.label.formatter = this.buildFormatter(data);
            baseSeries.label.rich.c.color = data.dataValueColor;
            chartOptions.series.push(baseSeries);
        }      
        return chartOptions;
    }   
    buildFormatter(data){
        let isSingleLine = data.value < 10;
        let format = [];
        let labelFormat = '{b|' + data.name + '}';
        let dataFormat = '{c|' + data.value +'%'+''+'}';
        format.push(labelFormat);
        format.push(dataFormat);
        if (isSingleLine == true){
            return format.join(' ');
        } 
        return format.join('\n');
    }
    getDefaultOptions(){
        return {
            series: [],
            yAxis: this.getBaseYAxis(),
        };        
    }
    getBaseYAxis(){
        return {
            type: 'value',
            show: false,
            min: 0,
            max: 100,
                    data: []           
        };
    }
    getBaseBarServiceForChart(){
        return {       
            type: 'bar',
            stack: 'total',
            color: '#548235',
            label: {
                show: true,
                fontSize: 10,
                //verticalAlign: 'top',
                fontWeight: 'bold',
                fontFamily: 'Franklin Gothic Medium Cond',
                color: '#000',
                formatter: '{b} {c}%',
                rich: {
                 c: {
                    fontFamily: "Franklin Gothic Medium Cond",
                    fontSize: 10,
                    color: '#000000'
                  },
                },
                position: 'right',
            },
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                borderColor: '#fff',
                borderWidth: 2,
                borderType: 'solid'
            },      
            barWidth: 100,
            data: [],
        }
    }
    getBaseOptionsForChart(){
        return {
            legend: {
                show: false
            },
            grid: {
                top: '0%',
                left: '0%',
                right: '0%',
                bottom: '0%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                min:0,
                max:100,            
                axisLabel: { show: false },
                axisTick: { show: false },
                axisLine: { show: false },
                splitLine: {
                show: false
                },
            }
        };
    }
    setContributionChartList(tempContributionChartList) {
        let contributionChartList = [];
        for (let chartIndex = 0; chartIndex < tempContributionChartList.length; chartIndex++) {
            if (chartIndex == 1) {
                break;
            }
            let contributionChart = tempContributionChartList[chartIndex];
            for (let individualChartIndex = 0; individualChartIndex < contributionChart.charts.length; individualChartIndex++) {
                contributionChart.charts[individualChartIndex].options =
                    this.setOptions(this.getDefaultOptions(), contributionChart.charts[individualChartIndex].periodName, contributionChart.charts[individualChartIndex].options,contributionChart.charts[individualChartIndex].header);

            }
            contributionChartList.push(contributionChart);
        }

        return contributionChartList;
    }
    getDefaultTextStyle(){
        return {
            fontSize: 12,
            fontFamily: "Franklin Gothic Medium Cond",
        }
    }
    getBaseEChartCriteria(){
        return {
            showLabels: true,  
            showLegend: true,
            showTooltip: true,
            colorPaletteId: 0,
            eChartType : "stacked-bar-vertical"
          };        
    }

}
export default new EChartsService();
